import TagManager, { TagManagerArgs } from 'react-gtm-module';
let tagManagerOptions: TagManagerArgs = {
  gtmId: 'GTM-K5DK6P2',
};
if (process.env.NODE_ENV !== 'production') {
  tagManagerOptions.auth = 'xk2mrhcAFfOAq0CcGs5-PA';
  tagManagerOptions.preview = 'env-7';
}
TagManager.initialize(tagManagerOptions);
